import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"DM_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\",\"800\"],\"variable\":\"--font-dm-sans\",\"display\":\"swap\"}],\"variableName\":\"dmSans\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/AdPopup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/CookieBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/PushPermissionPrompt.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/PWAInstallPrompt.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ServiceWorkerRegistrar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/SplashScreen.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/app/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/tailwind.css");
